import { fmt, pct, RAMP } from '../bamsShortsUtils';

// Shorts-per-order distribution table (0 / 1 / 2 / 3+ / any short) plus the
// data-quality callouts for facilities absent this week or reporting no shorts.
export function DistributionPanel({ absent, curRolled, curWeek, noData, onExport }) {
    return (
        <div className="panel">
            <div className="bar" style={{ marginBottom: 6 }}>
                <p className="ptitle" style={{ flex: 1, margin: 0 }}>
                    Shorts per order — including the clean ones
                </p>
                <button type="button" className="ghost tiny" onClick={onExport}>
                    Export CSV
                </button>
            </div>
            <p className="pnote">
                Denominator is orders packed, straight from the warehouse. Swap cards are excluded from shorts and
                reported separately.
            </p>
            <table>
                <thead>
                    <tr>
                        <th>Facility</th>
                        <th>Brand</th>
                        <th>Packed</th>
                        <th>0</th>
                        <th>1</th>
                        <th>2</th>
                        <th>3+</th>
                        <th>Any short</th>
                    </tr>
                </thead>
                <tbody>
                    {curRolled.map((e) => {
                        const cell = (v) => (
                            <>
                                {fmt(v)}
                                <span className="subpct">{pct(v, e.packed)}</span>
                            </>
                        );
                        return (
                            <tr key={`${e.brand}|${e.facility}`}>
                                <td>{e.facility}</td>
                                <td style={{ fontSize: 11, color: 'var(--muted)' }}>{e.brand.replace('_', ' ')}</td>
                                <td>{fmt(e.packed)}</td>
                                <td style={{ color: RAMP[0] }}>{cell(e.o0)}</td>
                                <td>{cell(e.o1)}</td>
                                <td>{cell(e.o2)}</td>
                                <td style={{ fontWeight: 600 }}>{cell(e.o3)}</td>
                                <td style={{ fontWeight: 600 }}>{cell(e.short_ord)}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            {absent.length ? (
                <div className="gap">
                    <b>Not in this week.</b>{' '}
                    {absent
                        .map((k) => {
                            const [b, f] = k.split('|');
                            return `${f} (${b.replace('_', ' ')})`;
                        })
                        .join(', ')}{' '}
                    packed in other loaded weeks but has no pack groups tagged week {curWeek}. Usually the pack week
                    rolls over on different days by site — check the prior week before reading this as a shutdown.
                </div>
            ) : null}
            {noData.length ? (
                <div className="gap">
                    <b>Not instrumented.</b>{' '}
                    {noData
                        .map((e) => `${e.facility} (${e.brand.replace('_', ' ')}, ${fmt(e.packed)} orders)`)
                        .join(', ')}{' '}
                    packed volume but recorded zero out-of-stock events. Treat as a reporting gap, not a clean facility.
                </div>
            ) : null}
        </div>
    );
}
